import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AcmicService } from '@mapfre-design-library/src/public_api';
import { MortgageeCustomToolTipComponent } from '../../../../widget/mortgagee-custom-tooltip/mortgagee-custom-tooltip.component';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, CustomDateFormatPipe, MortgageeCustomToolTipComponent],
  selector: 'app-bn-tab-header',
  templateUrl: './bn-tab-header.component.html',
  styleUrls: ['./bn-tab-header.component.scss']
})
export class BnTabHeaderComponent implements OnInit {

  @Input() policy: any;
  @Input() showMortgagee = false;
  @Input() hideTerm = false;
  isBillingDetails = false;
  isBillingDocuments = false;

  constructor(private acmicService:AcmicService, private router: Router) {
    
   }
  isAcmic :boolean;
  ngOnInit(): void {
    this.isAcmic=this.acmicService.isACMIC();
    const currUrl =  this.router.url;
    this.isBillingDetails = !this.isAcmic && currUrl.includes("billing-new") && currUrl.includes("details")
    this.isBillingDocuments = !this.isAcmic && currUrl.includes("billing-new") && currUrl.includes("documents")
  }

}
